var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09094 7.09082H12.9091",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09094 10H12.9091",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09094 12.9092H10",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-nan -nanL12.6078 18H2.72727C2.53439 18 2.3494 17.9234 2.21301 17.787C2.07662 17.6506 2 17.4656 2 17.2727V2.72727C2 2.53439 2.07662 2.3494 2.21301 2.21301C2.3494 2.07662 2.53439 2 2.72727 2H17.2727C17.4656 2 17.6506 2.07662 17.787 2.21301C17.9234 2.3494 18 2.53439 18 2.72727V12.6078C18 12.7034 17.9812 12.7979 17.9446 12.8862C17.9081 12.9744 17.8545 13.0546 17.787 13.1221L13.1221 17.787C13.0546 17.8545 12.9744 17.9081 12.8862 17.9446C12.7979 17.9812 12.7034 18 12.6078 18L-nan -nanL-nan -nanZ",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9342 12.9082H13.9091C13.3568 12.9082 12.9091 13.3559 12.9091 13.9082V17.9337",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.62148384c0bf20e6372f5215271740e1.svg";
export { ForwardRef as ReactComponent };